import type { ProcessTemplateListItemType } from '@econtractor/types';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import RowTitle from '../../shared/RowTitle';

interface ProcessDirTableRowProps {
    template: ProcessTemplateListItemType;
    onSelect?: (template: ProcessTemplateListItemType) => void;
    onEdit?: (template: ProcessTemplateListItemType) => void;
    onDelete?: (template: ProcessTemplateListItemType) => void;
}

const ProcessDirTableRow = ({ template, onSelect, onEdit, onDelete }: ProcessDirTableRowProps) => {
    const { t } = useTranslation(['Tasks', 'common']);
    const open = onSelect || onEdit;

    return (
        <tr className={open ? 'cursor-pointer' : undefined} onClick={open ? () => open(template) : undefined}>
            <td className="name">
                <RowTitle name={template.name} description={template.description} />
            </td>
            <td className="category text-break">
                {template.categoryName ? template.categoryName : <span className="text-muted">—</span>}
            </td>
            {onEdit || onDelete ? (
                <td className="action text-end" onClick={(e) => e.stopPropagation()}>
                    {onEdit ? (
                        <button
                            type="button"
                            className="btn btn-sm btn-light-secondary p-1 py-0 me-1"
                            onClick={() => onEdit(template)}
                            aria-label={t('common:buttons.change')}
                        >
                            <SolarIcon name="pencil" className="fs-14" />
                        </button>
                    ) : null}
                    {onDelete ? (
                        <Button
                            type="button"
                            size="sm"
                            className="p-1 py-0"
                            variant="light-danger"
                            onClick={() => onDelete(template)}
                            aria-label={t('common:buttons.delete')}
                        >
                            <SolarIcon name="trash3" />
                        </Button>
                    ) : null}
                </td>
            ) : null}
        </tr>
    );
};

export default ProcessDirTableRow;
